import React from 'react';
import {useParams} from 'react-router-dom'
import Loader from '../loading/loading.component';
import DisplayList from '../list-container/display-list.component';
import FetchTracksData from '../../custom-hooks/fetch-tracks-data';

function TagTracks(){
    let params = useParams();
    const {loading, tracks} = FetchTracksData(`https://ws.audioscrobbler.com/2.0/?method=tag.gettoptracks&tag=${params.tag}&api_key=627d96b414f95a9921f55e6a4b130cb3&format=json`,params);
    return (
        <div>
            {
                loading===undefined || loading?<Loader/>
                : 
                <DisplayList tracks={tracks}/>
            }
        </div>
    )
}

export default TagTracks;




// import React, {useEffect, useState} from 'react';
// import {useParams} from 'react-router-dom'
// import Loader from '../loading/loading.component';
// import DisplayList from '../list-container/display-list.component';

// function TagTracks(){
//     let params = useParams();
//     const [tracks, setTracks] = useState([]);
//     const [loading, setLoading] = useState(true);

//     useEffect( ()=> {        
//         async function fetchTracks(){
//             let result =  await fetch(`http://ws.audioscrobbler.com/2.0/?method=tag.gettoptracks&tag=${params.tag}&api_key=627d96b414f95a9921f55e6a4b130cb3&format=json`,
//                 {
//                     method: 'GET',                 
//                 }
//             )
//             .then(res => res.json()).then(res=>res.tracks.track);
//             let promises = result.map(track=>{
//                 return fetch(`https://api.genius.com/search?q=${track.name}&access_token=W9YRsCxZ1uJvh97K48L-EfCt50u6H_74Ywuz2oNUg8hwOhTeW8jrvcTOxwNzU0UJ`,
//                     {
//                         method:'GET',
//                     }
//                 )
//                 .then(res=>res.json());
//             });
//             let artistInfo = await Promise.all(promises);
//             let artistDetails = [];
//             artistInfo.forEach( (artist) =>{
//                 let obj = {};
//                 let response = artist.response.hits[0];
//                 obj["id"] = response.result.id;
//                 // eslint-disable-next-line                         
//                 obj["title"] = response.result.title.replace(/[^A-Za-z 0-9 \.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*/g, '');
//                 obj["artist"] = response.result.primary_artist.name;
//                 obj["image"] = response.result.song_art_image_thumbnail_url;
//                 artistDetails.push(obj);
//             });
//             setTracks(artistDetails);
//             setLoading(false);
//         }
//         fetchTracks();
//         // eslint-disable-next-line react-hooks/exhaustive-deps        
//     }, [])

//     return (
//         <div>
//             {
//                 loading===undefined || loading?<Loader/>
//                 : 
//                 <DisplayList tracks={tracks}/>
//             }
//         </div>
//     )
// }

// export default TagTracks;